import * as React from "react";
import { Flex, Box } from "grid-styled";
import { Link } from "react-router-dom";
import { Subscribe } from "unstated";

import { AppContainer } from "../../containers/App.container";
import NavBox from "./NavBox";
import { VerticalEllipsis } from "./verticalEllipsis";
import SayLogoText from "../SayLogoText/SayLogoText";
import styled from "../../styled-components";
import { media } from "../../breakpoints";
import EarningsCallBanner from "../EarningsCallBanner/EarningsCallBanner";

const LinkStyles = `color: #000;
  text-decoration: none;`;

const StyledLink = styled(Link)`
  ${LinkStyles};
  margin-left: 25px;
  margin-right: 25px;
`;
const StyledLinkA = styled.a`
  ${LinkStyles};
  margin-left: 25px;
  margin-right: 25px;
`;
const SayLink = styled.a``;

const OuterContainer = styled.div<{ backgroundColor: string | undefined }>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "transparent"};
  width: 100%;
  z-index: 1;
`;

const StyledFlex = styled(Flex)`
  ${media.TABLET`
      display: none;
    `};
`;

const NavContainer = Flex.extend`
  color: ${props => props.theme.colors.white};
  ${media.TABLET`
      margin-left: 0;
      justify-content: center;
    `};
`;

const PageName = styled.h1<{ linkColor: string | undefined }>`
  align-items: center;
  display: flex;
  font-size: 20px;
  font-weight: 400;
  margin-left: 25px;
  color: ${({ linkColor }) => (linkColor ? linkColor : "#000")};

  &:before {
    background: #c9c6c1;
    content: "";
    display: inline-block;
    height: 30px;
    margin-right: 30px;
    width: 1px;
  }
`;

const DesktopBox = styled(Box)`
  ${media.TABLET`
      display: none;
    `};
`;

const TabletBox = styled(Box)`
  display: none;
  ${media.TABLET`
      display: flex;
    `};
`;

const EllipsisButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  padding: 16px;

  svg g {
    transition: opacity 0.25s ease-in-out;
  }

  &:hover {
    svg g {
      opacity: 1;
    }
  }

  &:active,
  &:focus {
    svg g {
      opacity: 1;
    }
  }
`;

interface INavProps {
  pageName?: string;
  institutionsLink?: boolean;
  backgroundColor?: string;
  linkColor?: string;
  linkColorHover?: string;
  showSayLogo?: boolean;
  sayLogoFill?: string;
}

interface IContainerProps {
  navOpen: boolean;
  setNavOpen: (navOpen: boolean) => void;
}

class Nav extends React.Component<INavProps & IContainerProps, {}> {
  public render() {
    const {
      pageName,
      backgroundColor,
      linkColor,
      showSayLogo,
      navOpen,
      setNavOpen,
      sayLogoFill
    } = this.props;
    return (
      <OuterContainer backgroundColor={backgroundColor}>
        <NavContainer flexDirection="row" width={1} px={25} pt={10} pb={"5px"}>
          <Flex
            alignItems="top"
            flexDirection="row"
            justifyContent="space-between"
            width={1}
          >
            {showSayLogo ? (
              <Box width={1 / 3} alignSelf="center">
                <SayLink
                  href={
                    process.env.REACT_APP_WWW === "rocks"
                      ? "https://www.say.rocks/qa/"
                      : "https://www.saytechnologies.com/qa/"
                  }
                  aria-label="say"
                >
                  <SayLogoText fill={sayLogoFill} />
                </SayLink>
              </Box>
            ) : (
              <Box width={1 / 3} />
            )}{" "}
            {pageName ? (
              <PageName linkColor={linkColor}>{pageName}</PageName>
            ) : null}
            <StyledFlex
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              width={1 / 3}
            >
              <Box>
                <StyledLinkA
                  href={
                    process.env.REACT_APP_WWW === "rocks"
                      ? "https://www.say.rocks/earnings/"
                      : "https://www.saytechnologies.com/earnings/"
                  }
                  target="_blank"
                  aria-label="Earnings Calls page"
                >
                  Earnings Calls
                </StyledLinkA>
              </Box>
              <Box>
                <StyledLink to="/faq/" aria-label="FAQ page">
                  FAQ
                </StyledLink>
              </Box>
            </StyledFlex>
            <DesktopBox width={1 / 3}>
              {process.env.REACT_APP_EARNINGS_CALL_BANNER === "true" ? (
                <EarningsCallBanner />
              ) : null}
            </DesktopBox>
            <TabletBox>
              <EllipsisButton
                aria-label="Toggle Menu"
                onClick={() => {
                  setNavOpen(!navOpen);
                }}
              >
                <VerticalEllipsis />
              </EllipsisButton>
              <NavBox
                onClose={() => {
                  setNavOpen(false);
                }}
                isOpen={navOpen}
              />
            </TabletBox>
          </Flex>
        </NavContainer>
        <TabletBox width={1}>
          {process.env.REACT_APP_EARNINGS_CALL_BANNER === "true" ? (
            <EarningsCallBanner />
          ) : null}
        </TabletBox>
      </OuterContainer>
    );
  }
}

export default (props: INavProps) => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => (
      <Nav {...props} navOpen={app.state.navOpen} setNavOpen={app.setNavOpen} />
    )}
  </Subscribe>
);



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.tsx